import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import FilterContainer from "../FilterContainer";
import { IFilterProps } from "../../../../types/filter.type";
import FilterText from "../FilterText";
import { useSelector } from "react-redux";
import { asyncSearchList } from "../../../../utils/httpRequests";
import FilterList from "../FilterList";

function FilterReportList({ setCondition }: IFilterProps) {
  const originFilter: { [key: string]: any } = {
    title: "",
    trangThai: [],
  };
  const { token } = useSelector((state: any) => state.auth);
  const [filter, setFilter] = useState(originFilter);
  const [trangThais, setTrangThais] = useState<any[]>([]);

  const handleRefreshFilter = () => {
    setFilter(originFilter);
  };

  const getTrangThais = async () => {
    const resp = await asyncSearchList({
      apiCode: "trangthai",
      withIdApp: false,
      token,
      condition: {
        page: 1,
        limit: 999999,
        q: { ma_ct: "rp_dm" },
      },
    });
    if (resp && resp?.status === 200) {
      const data = resp?.data || [];
      const options = data.map((item: any) => ({
        label: item.ten_trang_thai,
        value: item.ma_trang_thai,
      }));
      setTrangThais(options);
    }
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.title) {
      condition.title = {
        $regex: filter.title?.split(" ")?.join(".*"),
        $options: "i",
      };
    }
    if (filter.trangThai?.length > 0) {
      condition.trang_thai = { $in: filter.trangThai };
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  useEffect(() => {
    getTrangThais();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FilterContainer handleRefreshFilter={handleRefreshFilter}>
      <Stack sx={{ width: "100%" }} gap={1}>
        <FilterText
          title="Tiêu đề"
          placeholder="Tìm theo tên tiêu đề"
          value={filter.title}
          onSearch={(value) => setFilter({ ...filter, title: value })}
        />
        <FilterList
          title="Trạng thái"
          items={trangThais}
          defaultValues={filter.trangThai}
          onChange={(value) => setFilter({ ...filter, trangThai: value })}
        />
      </Stack>
    </FilterContainer>
  );
}

export default FilterReportList;
